import { render } from "./TableSorting.vue?vue&type=template&id=d31cdb8c&scoped=true"
import script from "./TableSorting.vue?vue&type=script&lang=js"
export * from "./TableSorting.vue?vue&type=script&lang=js"

import "./TableSorting.vue?vue&type=style&index=0&id=d31cdb8c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31cdb8c"]])

export default __exports__